<template>
  <section class="about-section text-center" id="about">
    <div class="container px-4 px-lg-5">
      <div class="row gx-4 gx-lg-5 justify-content-center">
        <div class="col-lg-8">
          <h2 class="text-white mb-4">
            hand-crafted flutes, headjoints &amp; whistles
          </h2>
          <div class="text-white-50">
            <p>
              ironwood is a small one-person workshop in the beautiful German
              region of <i>Eifel</i>. After several years spent building
              whistles, I now focus on <b>Irish flutes</b> and wooden
              <b>headjoints for Boehm flutes</b> — and still make whistles on
              request. I do not mass produce or use industrialized processes:
              each instrument is turned, voiced and finished by using a
              combination of CNC-precision and manual work, with devotion to the
              craft.
            </p>
            <p>
              <img src="@/assets/img/lathe-grey.jpg" class="w-100" />
            </p>
            <p>
              <LinkComponent
                link-text="Contact ironwood"
                href="#contact"
                :inverted="true"
              />
              for available instruments or a custom commission.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import LinkComponent from "@/components/util/LinkComponent.vue";

export default {
  name: "AboutSectionComponent",
  components: { LinkComponent },
};
</script>
